import React, { useMemo } from "react";
import { SelectOption } from "src/pages/building/building-types";
import { BaseStateSelect } from "./BaseStateSelect";
import { BaseSelect2 } from "./BaseSelect2";
import useNavigate from "src/hooks/usePartnerNavigate";

import { useLocation, useParams } from "react-router-dom";
import { useModal } from "src/recoil/modalState/hook";
import qs from "qs";

type Props = {
  title: string;
  tabs?: Array<Tab>;
  activeTab?: Tab;
  clickTab?: Function;
  breadCrumbs?: Array<BreadCrumb>; // 제거 대상
  clickBreadCrumb?: Function; // 제거 대상
  className?: string;
  detailInfo?: Array<DetailInfo>;
  children?: React.ReactNode;
  selectValue?: string; // 셀렉트 선택값
  selectOptions?: Array<SelectOption>; // 셀렉트 옵션
  setSelectStateValue?: Function; // 셀렉트 변경함수
  colorType?: "product" | "workOrder" | "reservation" | "contract";
  selectDisabled?: boolean;
  selectOnFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
  selectValue2?: string;
  selectOptions2?: Array<SelectOption>;
  setSelectStateValue2?: Function;
  selectDisabled2?: boolean;
};

export type Tab = {
  value: string;
  label: string;
};

type BreadCrumb = {
  value: string;
  label: string;
};
type DetailInfo = {
  title: string;
  value: string | number;
};

export const ContentsTitle = ({
  tabs,
  title,
  activeTab,
  clickTab,
  className,
  detailInfo,
  selectValue,
  selectOptions,
  setSelectStateValue,
  children,
  colorType,
  selectDisabled,
  selectOnFocus,
  selectValue2,
  selectOptions2,
  setSelectStateValue2,
  selectDisabled2,
}: Props) => {
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const queryParams = useMemo(
    () =>
      qs.parse(location.search, {
        ignoreQueryPrefix: true,
        allowDots: true,
        decoder: (value) => value,
      }),
    [location],
  );

  const { setBaseModal } = useModal();

  const handleClickTab = (tab: { value: string; label: string }) => {
    const isAllowedToNavigate = (): boolean => {
      // 기본 정보 탭으로 이동하려는 경우는 항상 허용
      if (tab.value === "basicInfo") return true;
      if (queryParams.id) return true; // queryParams에 id가 있으면 허용
      if (params.id) return true; // params에 id가 있으면 허용
      if (params.visitApplyNumber && params.contractApplyNumber) return true; // 방문자 상세 페이지인 경우 허용

      //위에 조건들에 부합하지 않으면 이동불가 false리턴
      return false;
    };

    if (isAllowedToNavigate()) {
      // query parameter 에 tab 추가
      const newQueryParamStr = qs.stringify({ ...queryParams, tab: tab.value, id: queryParams.id || params.id }, { allowDots: true });
      navigate(location.pathname + "?" + decodeURIComponent(newQueryParamStr));
    } else {
      // 이동 불가능한 경우 모달 표시
      return setBaseModal({ isOpen: true, btnRightTitle: "확인", title: "기본정보가 저장되지 않았습니다" });
    }
  };

  return (
    <div className={`contents-title ${className ? className : ""}`}>
      <div className="flex-center">
        {children}
        <div className="contents-title__tab">
          {tabs?.map((tab: Tab, i: number) => {
            return (
              <div
                key={i}
                className={`${activeTab?.value === tab.value ? "active" : ""}`}
                onClick={() => (clickTab ? clickTab(tab) : handleClickTab(tab))}
                onMouseUp={(event) => {
                  if (event.button === 1) {
                    // 마우스의 휠 버튼 클릭 여부 확인
                    event.currentTarget.click();
                  }
                }}
              >
                <span>{tab.label}</span>
              </div>
            );
          })}
        </div>
      </div>
      <div className="flex-center">
        {detailInfo?.map((info, i) => {
          return (
            <div key={i + title + info.value} className="contents-title__info">
              {info.value && (
                <span className="no-wrap">
                  {info.title}: {info.value}
                </span>
              )}
            </div>
          );
        })}

        {selectValue2 && selectOptions2 && setSelectStateValue2 && (
          <div className="minmax100 mr10">
            <BaseSelect2 value={selectValue2} selectOptions={selectOptions2} setStateValue={setSelectStateValue2} isDisabled={selectDisabled2} />
          </div>
        )}
        {selectValue && selectOptions && setSelectStateValue && (
          <div className="minmax100">
            <BaseStateSelect
              value={selectValue}
              selectOptions={selectOptions}
              setStateValue={setSelectStateValue}
              isDisabled={selectDisabled}
              colorType={colorType}
            />
          </div>
        )}
      </div>
    </div>
  );
};
